import type { Patient } from '@medplum/fhirtypes';

// Fusión manual de fichas duplicadas (C-004, D-030). La bóveda enlaza los dos `Patient` con `Patient.link`: el registro que se UNIÓ queda `active: false` con un
// `replaced-by` hacia el registro vigente, y el vigente lleva un `replaces` hacia cada registro unido. La historia clínica NO se mueve ni se reescribe: esta
// pantalla solo AVISA y deja abrir el otro registro. Pura: recibe el Patient, devuelve los enlaces.

export type EnlaceFusion = { tipo: 'replaced-by' | 'replaces'; id: string };

export function enlacesDeFusion(patient: Pick<Patient, 'link'>): EnlaceFusion[] {
  const salida: EnlaceFusion[] = [];
  for (const l of patient.link ?? []) {
    if (l.type !== 'replaced-by' && l.type !== 'replaces') continue;
    const m = /^Patient\/([A-Za-z0-9\-.]{1,64})$/.exec(l.other?.reference ?? '');
    if (m && !salida.some((e) => e.tipo === l.type && e.id === m[1])) salida.push({ tipo: l.type, id: m[1]! });
  }
  return salida;
}

/** ¿Este `Patient` es un registro FUSIONADO en otro (tiene un `link` `replaced-by`, aunque la referencia venga mal formada)? Ningún Encounter nuevo se abre sobre él. */
export function esRegistroFusionado(patient: Pick<Patient, 'link'>): boolean {
  return (patient.link ?? []).some((l) => l.type === 'replaced-by');
}

/** Se intentó abrir una consulta (o una nota/receta) sobre un registro fusionado: la atención va en el registro vigente (`vigenteId`, si se pudo leer). */
export class RegistroFusionadoError extends Error {
  constructor(
    message: string,
    readonly vigenteId: string | null
  ) {
    super(message);
    this.name = 'RegistroFusionadoError';
  }
}
